import { createAction, props } from '@ngrx/store';

import { Error, TipoActividad } from '@rpe/registro-personas-empresas-lib';

// LOAD
export const entityTiposActividadLoadRequest = createAction(
  '[ENTITYTIPOSACTIVIDAD] Load Request'
);

export const entityTiposActividadLoadFailure = createAction(
  '[ENTITYTIPOSACTIVIDAD] Load Failure',
  props<{ error: Error }>()
);

export const entityTiposActividadLoadSuccess = createAction(
  '[ENTITYTIPOSACTIVIDAD] Load Success',
  props<{ items: TipoActividad[] }>()
);
